import {
  GET_TEMPLATE,
  GET_TEMPLATE_SUCCESS,
  GET_TEMPLATE_FAIL,
  SAVE_TEMPLATE,
  SAVE_TEMPLATE_SUCCESS,
  SAVE_TEMPLATE_FAIL,
  GET_REPORT,
  GET_REPORT_SUCCESS,
  GET_REPORT_FAIL,
  GET_DRAFT_REPORT,
  GET_DRAFT_REPORT_SUCCESS,
  GET_DRAFT_REPORT_FAIL,
  SAVE_REPORT,
  SAVE_REPORT_SUCCESS,
  SAVE_REPORT_FAIL,
  UPDATE_REPORT,
  UPDATE_REPORT_SUCCESS,
  UPDATE_REPORT_FAIL,
  DELETE_REPORT,
  DELETE_REPORT_SUCCESS,
  DELETE_REPORT_FAIL,
  RESET_MESSAGE,
  PUBLISH_DRAFT,
  PUBLISH_DRAFT_SUCCESS,
  PUBLISH_DRAFT_FAIL,
} from "./actionTypes";
import { LOGOUT_LOGGEDIN_USER } from "../auth/login/actionTypes";
import RequestHandler from "../../helpers/RequestHandler";

const signOutUser = () => ({
  type: LOGOUT_LOGGEDIN_USER,
});

const getTemplate = () => ({
  type: GET_TEMPLATE,
});

const getTemplateSuccess = (item) => ({
  type: GET_TEMPLATE_SUCCESS,
  payload: item,
});

const getTemplateFail = (error) => ({
  type: GET_TEMPLATE_FAIL,
  payload: error,
});

export const getTemplateHandler = (platform) => {
  return (dispatch) => {
    dispatch(getTemplate());
    RequestHandler.get(`/operational/template?platform=${platform}`)
      .then((response) => response.data.data)
      .then((response) => {
        const { template } = response || {};
        dispatch(getTemplateSuccess(template || {}));
      })
      .catch(function (error) {
        const { response } = error || {};
        const { data } = response || {};
        if (data && data.message === "Invalid Token Input") {
          dispatch(signOutUser());
        } else {
          let ErrMsg = data?.message ? data.message : JSON.stringify(data);
          if (ErrMsg && ErrMsg.includes("not found")) ErrMsg = null;
          dispatch(getTemplateFail(ErrMsg));
        }
      });
  };
};

const saveTemplate = () => ({
  type: SAVE_TEMPLATE,
});

const saveTemplateSuccess = (item) => ({
  type: SAVE_TEMPLATE_SUCCESS,
  payload: item,
});

const saveTemplateFail = (error) => ({
  type: SAVE_TEMPLATE_FAIL,
  payload: error,
});

export const saveTemplateHandler = (body) => {
  return (dispatch) => {
    dispatch(saveTemplate());
    RequestHandler.post("/operational/template", body)
      .then((response) => response.data.data)
      .then((response) => {
        const { template } = response || {};
        dispatch(getTemplateSuccess(template || {}));
        if (template)
          dispatch(saveTemplateSuccess("Template saved successfully."));
      })
      .catch(function (error) {
        const { response } = error || {};
        const { data } = response || {};
        if (data && data.message === "Invalid Token Input") {
          dispatch(signOutUser());
        } else {
          let ErrMsg = data?.message ? data.message : JSON.stringify(data);
          if (ErrMsg && ErrMsg.includes("not found")) ErrMsg = null;
          dispatch(saveTemplateFail(ErrMsg));
        }
      });
  };
};

const saveReport = () => ({
  type: SAVE_REPORT,
});

const saveReportSuccess = (item) => ({
  type: SAVE_REPORT_SUCCESS,
  payload: item,
});

const saveReportFail = (error) => ({
  type: SAVE_REPORT_FAIL,
  payload: error,
});

export const saveReportHandler = (body) => {
  return (dispatch) => {
    dispatch(saveReport());
    RequestHandler.post("/operational/report", body)
      .then((response) => response.data.data)
      .then((response) => {
        const { report } = response || {};
        dispatch(getReportSuccess(report || {}));
        if (report) dispatch(saveReportSuccess("Report saved successfully."));
      })
      .catch(function (error) {
        const { response } = error || {};
        const { data } = response || {};
        if (data && data.message === "Invalid Token Input") {
          dispatch(signOutUser());
        } else {
          let ErrMsg = data?.message ? data.message : JSON.stringify(data);
          if (ErrMsg && ErrMsg.includes("not found")) ErrMsg = null;
          dispatch(saveReportFail(ErrMsg));
        }
      });
  };
};

const getDraftReport = () => ({
  type: GET_DRAFT_REPORT,
});

const getDraftReportSuccess = (item) => ({
  type: GET_DRAFT_REPORT_SUCCESS,
  payload: item,
});

const getDraftReportFail = (error) => ({
  type: GET_DRAFT_REPORT_FAIL,
  payload: error,
});

export const getDraftReportHandler = () => {
  return (dispatch) => {
    dispatch(getDraftReport());
    const API_URL = "/operational/draft";
    RequestHandler.get(API_URL)
      .then((response) => response.data.data)
      .then((response) => {
        const { reports } = response || {};
        dispatch(getDraftReportSuccess(reports || {}));
      })
      .catch(function (error) {
        const { response } = error || {};
        const { data } = response || {};
        if (data && data.message === "Invalid Token Input") {
          dispatch(signOutUser());
        } else {
          let ErrMsg = data?.message ? data.message : JSON.stringify(data);
          if (ErrMsg && ErrMsg.includes("not found")) ErrMsg = null;
          dispatch(getDraftReportFail(ErrMsg));
        }
      });
  };
};

const updateReport = () => ({
  type: UPDATE_REPORT,
});

const updateReportSuccess = (item) => ({
  type: UPDATE_REPORT_SUCCESS,
  payload: item,
});

const updateReportFail = (error) => ({
  type: UPDATE_REPORT_FAIL,
  payload: error,
});

export const updateReportHandler = (id, body) => {
  return (dispatch) => {
    dispatch(updateReport());
    RequestHandler.post(`/operational/report/${id}`, body)
      .then((response) => response.data.data)
      .then((response) => {
        const { report } = response || {};
        dispatch(getReportSuccess(report || {}));
        if (report)
          dispatch(updateReportSuccess("Report updated successfully."));
      })
      .catch(function (error) {
        const { response } = error || {};
        const { data } = response || {};
        if (data && data.message === "Invalid Token Input") {
          dispatch(signOutUser());
        } else {
          let ErrMsg = data?.message ? data.message : JSON.stringify(data);
          if (ErrMsg && ErrMsg.includes("not found")) ErrMsg = null;
          dispatch(updateReportFail(ErrMsg));
        }
      });
  };
};

const getReport = () => ({
  type: GET_REPORT,
});

const getReportSuccess = (item) => ({
  type: GET_REPORT_SUCCESS,
  payload: item,
});

const getReportFail = (error) => ({
  type: GET_REPORT_FAIL,
  payload: error,
});

export const getReportHandler = (query = {}) => {
  return (dispatch) => {
    dispatch(getReport());
    let API_URL = "/operational/report";
    if (Object.keys(query).length > 0) {
      API_URL += `?`;
      let QueryParams = [];
      Object.keys(query).forEach((queryKey) => {
        QueryParams.push(`${queryKey}=${encodeURIComponent(query[queryKey])}`);
      });
      API_URL += QueryParams.join("&");
    }
    RequestHandler.get(API_URL)
      .then((response) => response.data.data)
      .then((response) => {
        const { report } = response || {};
        dispatch(getReportSuccess(report || {}));
      })
      .catch(function (error) {
        const { response } = error || {};
        const { data } = response || {};
        if (data && data.message === "Invalid Token Input") {
          dispatch(signOutUser());
        } else {
          let ErrMsg = data?.message ? data.message : JSON.stringify(data);
          if (ErrMsg && ErrMsg.includes("not found")) ErrMsg = null;
          dispatch(getReportFail(ErrMsg));
        }
      });
  };
};

const deleteReport = () => ({
  type: DELETE_REPORT,
});

const deleteReportSuccess = (item) => ({
  type: DELETE_REPORT_SUCCESS,
  payload: item,
});

const deleteReportFail = (error) => ({
  type: DELETE_REPORT_FAIL,
  payload: error,
});

export const deleteReportHandler = (id) => {
  return (dispatch) => {
    dispatch(deleteReport());
    let API_URL = `/operational/draft/${id}`;
    RequestHandler.delete(API_URL)
      .then((response) => response.data.data)
      .then((response) => {
        const { reports } = response || {};
        dispatch(deleteReportSuccess(reports || {}));
      })
      .catch(function (error) {
        const { response } = error || {};
        const { data } = response || {};
        if (data && data.message === "Invalid Token Input") {
          dispatch(signOutUser());
        } else {
          let ErrMsg = data?.message ? data.message : JSON.stringify(data);
          if (ErrMsg && ErrMsg.includes("not found")) ErrMsg = null;
          dispatch(deleteReportFail(ErrMsg));
        }
      });
  };
};

const resetMessage = () => ({
  type: RESET_MESSAGE,
});

export const resetMessageHandle = () => {
  return (dispatch) => {
    dispatch(resetMessage());
  };
};

const publishDraft = () => ({
  type: PUBLISH_DRAFT,
});

const publishDraftSuccess = (item) => ({
  type: PUBLISH_DRAFT_SUCCESS,
  payload: item,
});

const publishDraftFail = (error) => ({
  type: PUBLISH_DRAFT_FAIL,
  payload: error,
});

export const publishDraftHandler = (id) => {
  return (dispatch) => {
    dispatch(publishDraft());
    RequestHandler.post(`/operational/publish-report/${id}`, {
      status: "published",
    })
      .then((response) => response.data.data)
      .then((response) => {
        const { reports } = response || {};
        dispatch(publishDraftSuccess(reports));
      })
      .catch(function (error) {
        const { response } = error || {};
        const { data } = response || {};
        if (data && data.message === "Invalid Token Input") {
          dispatch(signOutUser());
        } else {
          let ErrMsg = data?.message ? data.message : JSON.stringify(data);
          if (ErrMsg && ErrMsg.includes("not found")) ErrMsg = null;
          dispatch(publishDraftFail(ErrMsg));
        }
      });
  };
};
